import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SlidersVendor() {
      const [isScrolled, setIsScrolled] = useState(false);
    
      const settings = {
        slidesToShow: 8, 
        slidesToScroll: 1, 
        autoplay: true,
        autoplaySpeed: 2000, 
        arrows: false, 
        dots: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 1024, // For screens smaller than 1024px
            settings: {
              slidesToShow: 5,
            },
          },
          {
            breakpoint: 768, // For screens smaller than 768px
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 520, // For screens smaller than 520px
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      };
    
      const handleScroll = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        setIsScrolled(scrollTop > 50);
      };
    
      useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }, []);
    
        const sliderRef = useRef(null);
      
        const play = () => {
          sliderRef.current.slickPlay();
        };
        const pause = () => {
          sliderRef.current.slickPause();
        };
  

  return (
    <div>
    <div className="about-company-main-sec">
    <div className="container">
        <div className="row">
            <div className="boxv1">
                <h5 className="tour-details-h5">Tours Package</h5>
                <div className={`tours-package-slides slider slides-wrapper ${ isScrolled ? "slider" : ""}`}>

                <Slider ref={sliderRef} {...settings}>
                    <div>
                        <a href="#">
                            <img className="vendour-tour-package-img" src="assets/img/tours/bali.jpg"/>
                            <h5 className="holiday-theme-name">Family Retreat</h5>
                        </a>
                    </div>

                    <div>
                        <a href="#" target="_blank">
                            <img className="vendour-tour-package-img" src="assets/img/tours/europe.jpg"/>
                            <h5 className="holiday-theme-name">Beach</h5>
                        </a>
                    </div>

                    <div>
                        <a href="#" target="_blank">
                            <img className="vendour-tour-package-img" 
                            src="assets/img/tours/dubai.jpg"/>
                            <h5 className="holiday-theme-name">Luxury</h5>
                        </a>
                    </div>

                    <div>
                        <a href="#" target="_blank">
                            <img className="vendour-tour-package-img" 
                            src="assets/img/tours/australia.jpg"/>
                            <h5 className="holiday-theme-name">Honeymoon</h5>
                        </a>
                    </div>

                    <div>
                        <a href="#" target="_blank">
                            <img className="vendour-tour-package-img" 
                            src="assets/img/tours/singapore.jpg"/>
                            <h5 className="holiday-theme-name">Adventure</h5>
                        </a>
                    </div>

                    <div>
                        <a href="#" target="_blank">
                            <img className="vendour-tour-package-img" 
                            src="assets/img/tours/new-year-deals/andaman.jpg"/>
                            <h5 className="holiday-theme-name">Pilgrimage</h5>
                        </a>
                    </div>


                    <div>
                        <a href="#" target="_blank">
                            <img className="vendour-tour-package-img" 
                            src="assets/img/tours/trending/mumbai.jpg"/>
                            <h5 className="holiday-theme-name">Safari Trails</h5>
                        </a>
                    </div>

                    <div>
                        <a href="#" target="_blank">
                            <img className="vendour-tour-package-img" 
                            src="assets/img/tours/trending/goa.jpg"/>
                            <h5 className="holiday-theme-name">Weekend</h5>
                        </a>
                    </div>

                    <div>
                        <a href="#" target="_blank">
                            <img className="vendour-tour-package-img" 
                            src="assets/img/tours/international/bhutan.png"/>
                            <h5 className="holiday-theme-name">Youth Holidays</h5>
                        </a>
                    </div>
</Slider>
                </div>

            </div>

        </div>
    </div>
</div>
    </div>
  );
}

export default SlidersVendor;
